export const ACCOUNT_DELETION_COPY = `We're sad to see you go, but we understand that sometimes you need to move on. This action is permanent and cannot be undone.
\nYour account and all associated data will be permanently deleted. This includes your tasks, preferences, and any other information we have stored.
\nIf you have an active subscription, we'll also cancel it and unsubscribe you at the same time.
\nIf you're sure you want to delete your account, just tell us to "duck it" one last time.
`;
